import lodash from "lodash";
const CRCModule = {
  getCRC: function(inputData) {
    // CRC 6304를 픽스로 넣어줘야함 (우선은 myQR때에만 쓰이고 CRC 값을 모르기 때문에 길이값이 4자리로 픽스하고 진행)
    inputData += "6304"; // napasQR > 6304 픽스로 넣어둠 (myQR 생성)
    console.log("inputData : " + inputData);
    const inputDataBytes = [...Buffer.from(inputData, "ascii")];
    const calculatedCRCValue = this.calculatedCRC16(inputDataBytes);
    console.log("inputData :" + inputData);

    // CRC 계산한 것이 혹시 16진수로 문자열 형태로 바꿀때 0을 공백으로 인식할 경우
    var calculatedCRCValue2 = calculatedCRCValue.toString(16); // CRC 변환한 값이 4자리인 경우 반환할 값
    console.log("calculatedCRCValue2 : " + calculatedCRCValue2);
    console.log("lodash calculatedCRCValue2 : " + lodash.padStart(calculatedCRCValue2, 4, "0"));
    return lodash.padStart(calculatedCRCValue2, 4, "0");
  },

  validateCRC: function(qrString, operGroupCd) {

    console.log("operGroupCd : " + operGroupCd);

    try {

      var qrStringWithoutCRC = qrString.substr(0, qrString.length - 4);
      var qrCRC = qrString.substr(qrString.length - 4);

      console.log("qrStringWithoutCRC: " + qrStringWithoutCRC);
      console.log("qrCRC: " + qrCRC);

      // CRC가 없는 QR String으로 VN - ASCII, MM - UTF-8 변환
      const inputDataBytes = operGroupCd.includes("VN") ? [...Buffer.from(qrStringWithoutCRC, "ascii")] : new TextEncoder().encode(qrStringWithoutCRC);

      const calculatedCRCValue = this.calculatedCRC16(inputDataBytes);  // 해당 바이트를 CRC 알고리즘을 통해 값을 추출
      var calculatedCRCValue2 = calculatedCRCValue.toString(16); // CRC 변환한 값이 4자리인 경우 반환할 값
      var calculatedCRCValue3 = ""; // CRC 변환한 값이 4자리가 아닌 경우 0으로 채운뒤 반환할 값 or 원래 4자리라면 Value2를 이식받을 값 -> 비교대상

      if (operGroupCd.includes("VN")) {
        if (calculatedCRCValue2.length == 4) {
          calculatedCRCValue3 = calculatedCRCValue2; // 올바른 CRC Value2 -> CRC Value3에 이식
        } else {
          calculatedCRCValue3 = lodash.padStart(calculatedCRCValue2, 4, "0");
        }
      } else {
        calculatedCRCValue3 = calculatedCRCValue2.padStart(4, "0");
      }

       // CRC 검증
       if (qrCRC == calculatedCRCValue3) {
        return true;
      } else {
        if (qrCRC == calculatedCRCValue3.toLocaleUpperCase()) {
          return true;
        } else {
          return false;
        }
      }

    } catch (error) {
      console.log("CRC 검증 오류");
      return false;
    }
  },

  calculatedCRC16: function(data) {
    const polynomial = 0x1021; // 다항식 ('1021') hex
    let crc = 0xffff; // 초깃값 CRC 셋팅
    for (let byte of data) {
      crc ^= byte << 8;
      for (let bit = 0; bit < 8; bit++) {
        if (crc & 0x8000) {
          crc = (crc << 1) ^ polynomial;
        } else {
          crc = crc << 1;
        }
      }
    }
    let realCrc = crc & 0xffff;
    console.log("realCrc : " + realCrc);
    return realCrc;
  },
};
// 비동기로 빠르게 QRInstance 뽑아내기
// function getInstance(operGroupCd, qrString) {
//   const { default: qrInstance } = operGroupCd.includes("VN")
//   ?  import("./NapasQR.js")
//   :  import("./MMQR.js");

//   var qrItem = operGroupCd.includes("VN") ? "" : qrInstance.QRtoValue(qrString); // 베트남일때 Item을 따로 만들 필요가 없음, 미얀마일땐 Item을 뽑아내야함
//   var hashMap = operGroupCd.includes("VN") ? qrInstance.convertQRStringtoKV(qrString) : qrInstance.getMMQRHashMap(qrItem);
//   return hashMap
// }
export default CRCModule;
